import React from 'react';
import { Helmet } from 'react-helmet';
import CompanyHistory from './HistoryItem';
import Statistics from './Statistics';
import ExperienceTeam from './ExperienceTeam';
import ExperienceSection from './ExperienceSection';


const About = () => {
  return (
    <>

<Helmet>
  <title>Contact: +91 8793220265 | Anjali Enterprises | Aluminium Glass Office Partition Services</title>
  <meta name="description" content="Anjali Enterprises provides all types of Aluminium Glass Office Partition solutions in Pune, including office glass partition installation, room dividers, and premium soundproof partitions. Call +91 8793220265 for more details." />
  <meta name="keywords" content="Aluminium Glass Partition, Office Glass Partition Installation, Glass Partition for Offices in Pune, Office Room Divider Glass, Aluminium Partitioning for Offices, Partitioning Solutions, Best Office Partitions in Pune, Aluminium Framed Glass Office Partition, Modern Office Partitions, Partition Wall Installation, Pune Office Glass Partition Service, Glass Partition Work in Pune, Premium Office Partitions, Soundproof Glass Partitions, Glass Partition Contractors Pune" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Aluminium Glass Office Partition Services" />
  <meta property="og:description" content="Anjali Enterprises provides all types of Aluminium Glass Office Partition solutions in Pune, including office glass partition installation, room dividers, and premium soundproof partitions. Call +91 8793220265 for more details." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/office-partition-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/aluminium-glass-office-partition" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises provides all types of Aluminium Glass Office Partition solutions in Pune, including office glass partition installation, room dividers, and premium soundproof partitions. Call +91 8793220265 for more details.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/aluminium-glass-office-partition",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/office-partition-service.jpg",
        "priceRange": "₹1000 - ₹10000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/aluminium-glass-office-partition",
          "priceCurrency": "INR",
          "price": "1000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "45"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Rajesh T"
            },
            "datePublished": "2024-08-10",
            "reviewBody": "Anjali Enterprises did an excellent job with our office partition. The glass partition installation was smooth, and the final result looks amazing. Highly recommended!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Sanya M"
            },
            "datePublished": "2024-09-18",
            "reviewBody": "I am very pleased with the soundproof glass partitions they installed in our office. The quality and finishing are top-notch."
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/aluminium-glass-office-partition"
        },
        "keywords": "Aluminium Glass Partition, Office Glass Partition Installation, Glass Partition for Offices in Pune, Office Room Divider Glass, Aluminium Partitioning for Offices, Partitioning Solutions, Best Office Partitions in Pune, Aluminium Framed Glass Office Partition, Modern Office Partitions, Partition Wall Installation, Pune Office Glass Partition Service, Glass Partition Work in Pune, Premium Office Partitions, Soundproof Glass Partitions, Glass Partition Contractors Pune"
      }
    `}
  </script>
</Helmet>


      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1>About</h1>
        </div>
      </div>

      <ExperienceSection />
      <CompanyHistory />
      <Statistics />
      <ExperienceTeam />

    </>
  );
};

export default About;
